import {Component, Input} from '@angular/core';
import { CommonModule } from '@angular/common';

export enum PageSize { SINGLE, HALF , TWO_THIRD}

@Component({
  selector: 'app-page',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './page.component.html'
})
export class PageComponent {
  @Input() size: PageSize = PageSize.SINGLE
  @Input() maxWidth?: string;
  @Input() marginTop?: string;
  @Input() rightFirstOnMobile = false;

  PageSize = PageSize;
}
